import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Portfolios from './pages/Portfolios';
import Banners from './pages/Banners';
import Contacts from './pages/Contacts';
import Tracker from './pages/Tracker';
import BranchManagement from './pages/BranchManagement';
import GalleryManagement from './pages/GalleryManagement';
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="portfolios" element={<Portfolios />} />
        <Route path="banners" element={<Banners />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="tracker" element={<Tracker />} />
        <Route path="branches" element={<BranchManagement/>}/>
        <Route path="gallery" element={<GalleryManagement/>}/>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
